export default "__VITE_ASSET__CS7TEfY___"